import { defineStore } from "pinia";
import { RouteRecordRaw } from "vue-router";
const MAX_LENGTH = 10;

interface RouteState {
  routeHistroy: Array<RouteRecordRaw>;
}

export const routeStore = defineStore({
  id: "route",
  persist: false,
  state: (): RouteState => ({
    routeHistroy: [],
  }),
  getters: {
    preRoute(): RouteRecordRaw | undefined {
      return this.routeHistroy[this.routeHistroy.length - 1];
    },
  },
  actions: {
    backRoute() {
      return this.routeHistroy.pop();
    },
    addHistory(route: RouteRecordRaw) {
      if (this.routeHistroy.length >= MAX_LENGTH) {
        this.routeHistroy.shift();
      } else if (
        this.routeHistroy.length === 0 ||
        (this.routeHistroy[this.routeHistroy.length - 1] &&
          this.routeHistroy[this.routeHistroy.length - 1].name !== route.name)
      ) {
        this.routeHistroy.push(route);
        console.log(this.routeHistroy);
      }
    },
  },
});
